import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import FormCheckbox from "../../../components/form/FormCheckbox";
import FormDropdown from "../../../components/form/FormDropdown";
import FormText from "../../../components/form/FormText";
import HelpIcon from "../../../components/interface/HelpIcon";
import {
  CSV_IMPORT_COLUMN_INFO,
  CSV_IMPORT_COLUMN_INFO_TOOLTIP,
  CSV_IMPORT_DURATION_PRECISIONS
  // CSV_LEARN_MORE_LINK_LABEL
} from "../../../constants/importExportFile";
// import FormButton from "../../../components/form/FormButton";

const learnMoreLink = null;
{
  /* <FormButton linkStyle label={CSV_LEARN_MORE_LINK_LABEL} />; */
}

const colorColumnInfo = () => {
  return (
    <FormText>
      {CSV_IMPORT_COLUMN_INFO["color"]} {learnMoreLink}
    </FormText>
  );
};

const endDateColumnInfo = (isOverDuration, onChange) => (
  <FormCheckbox
    label={CSV_IMPORT_COLUMN_INFO["endDate"]}
    checkboxState={isOverDuration}
    onChange={onChange}
    helpTooltip={CSV_IMPORT_COLUMN_INFO_TOOLTIP["endDate"]}
  />
);

const durationColumnInfo = (precision, onChange) => {
  return (
    <FormDropdown
      label={CSV_IMPORT_COLUMN_INFO["duration"]}
      value={precision}
      options={CSV_IMPORT_DURATION_PRECISIONS}
      onChange={onChange}
      helpTooltip={CSV_IMPORT_COLUMN_INFO_TOOLTIP["duration"]}
    />
  );
};

const tagsColumnInfo = (shouldCreateNewTag, onChange) => (
  <FormCheckbox label={CSV_IMPORT_COLUMN_INFO["tags"]} checkboxState={shouldCreateNewTag} onChange={onChange} />
);

const internalIdColumnInfo = () => {
  return (
    <FormText>
      {CSV_IMPORT_COLUMN_INFO["internalId"]} {learnMoreLink}
      <HelpIcon tooltip={CSV_IMPORT_COLUMN_INFO_TOOLTIP["internalId"]} />
    </FormText>
  );
};

const blockColumnInfo = () => {
  return (
    <FormText>
      {CSV_IMPORT_COLUMN_INFO["blocking"]} {learnMoreLink}
      <HelpIcon tooltip={CSV_IMPORT_COLUMN_INFO_TOOLTIP["blocking"]} />
    </FormText>
  );
};

const relationshipColumnInfo = (value, onChange) => {
  return (
    <FormCheckbox
      label={CSV_IMPORT_COLUMN_INFO["relationItem"]}
      checkboxState={value}
      onChange={onChange}
      helpTooltip={CSV_IMPORT_COLUMN_INFO_TOOLTIP["relationItem"]}
    />
  );
};

const isRelationshipColumn = (columnType, typesById, referencesById) => {
  return typesById.get(columnType) || referencesById.get(columnType);
};

const ImportCsvColumnInfo = ({ columnType, value, onChange, typesById, referencesById }) => {
  switch (columnType) {
    case "color":
      return colorColumnInfo();
    case "endDate":
      return endDateColumnInfo(value, onChange);
    case "duration":
      return durationColumnInfo(value, onChange);
    case "tags":
      return tagsColumnInfo(value, onChange);
    case "internalId":
      return internalIdColumnInfo(value, onChange);
    case "blocking":
      return blockColumnInfo();
    default:
      return isRelationshipColumn(columnType, typesById, referencesById)
        ? relationshipColumnInfo(value, onChange)
        : null;
  }
};

ImportCsvColumnInfo.propTypes = {
  columnType: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  typesById: ImmutablePropTypes.map.isRequired,
  referencesById: ImmutablePropTypes.map.isRequired
};

export default ImportCsvColumnInfo;
